<template>
  <div class="modal reg-modal page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="container">
            <div class="form">
              <div class="form-wrapper">
                <div class="form-fields register-content">
                  <div class="tabs">
                    <div
                      class="title title-18 gray"
                      @click="$parent.openSignIn"
                    >
                      <b>Login</b>
                    </div>
                    <div class="title title-18">
                      <b>Sign Up</b>
                    </div>
                  </div>
                  <div class="form-fields-wrapper">
                    <label>
                      <div class="desc">*First name</div>
                      <input
                        type="text"
                        placeholder="First name"
                        v-model="name"
                      />
                    </label>
                    <label>
                      <div class="desc">*Last Name</div>
                      <input
                        type="text"
                        placeholder="Last Name"
                        v-model="surname"
                      />
                    </label>
                    <label>
                      <div class="desc">*Email</div>
                      <input type="email" placeholder="Email" v-model="email" />
                    </label>
                    <label>
                      <div class="desc">*Phone</div>
                      <input type="tel" placeholder="Phone" v-model="phone" />
                    </label>
                    <label>
                      <div class="desc">*Password</div>
                      <input
                        type="password"
                        placeholder="Password"
                        v-model="pass"
                      />
                    </label>
                    <label>
                      <div class="desc">*Confirm Password</div>
                      <input
                        type="password"
                        placeholder="Confirm Password"
                        v-model="passConfirm"
                      />
                    </label>
                    <div class="cta-container">
                      <div class="chekbox-container">
                        <label class="chekbox-label">
                          <div class="chekbox-label-wrapper">
                            <input
                              type="checkbox"
                              name="terms"
                              v-model="terms"
                            />
                            <div class="checkbox"></div>
                            <span class="title"
                              >I confirm that I am at least 18 years old and
                              agree to the
                            </span>
                            <router-link
                              v-if="termsAndConditionsUrl"
                              :to="termsAndConditionsUrl"
                              class="title"
                              >Terms and Conditions</router-link
                            >
                            <span class="title"> and </span>
                            <router-link
                              v-if="privacyPolicyUrl"
                              :to="privacyPolicyUrl"
                              class="title"
                              >Privacy Notice
                            </router-link>
                          </div>
                        </label>
                      </div>
                      <button
                        :class="[
                          'button',
                          { disabled: !requiredRegisterFieldsAreFilled },
                        ]"
                        @click="submitRegister"
                      >
                        <span>Sign up</span>
                      </button>
                    </div>
                    <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">
                        {{ $parent.error }}
                      </div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Registration",
  props: [],
  components: {},
  data: function () {
    return {
      email: "",
      pass: "",
      name: "",
      surname: "",
      phone: "",
      passConfirm: "",
      terms: false,
    };
  },
  mounted() {},
  computed: {
    ...mapGetters("staticPages", ["getTermsPage", "getPrivacyPage"]),
    privacyPolicyUrl() {
      const privacyPage = this.getPrivacyPage;
      return privacyPage
        ? { name: "TextPage", params: { identifier: privacyPage.slug } }
        : null;
    },
    termsAndConditionsUrl() {
      const termsPage = this.getTermsPage;
      return termsPage
        ? { name: "TextPage", params: { identifier: termsPage.slug } }
        : null;
    },
    requiredRegisterFieldsAreFilled() {
      let fieldsAreFilled;
      if (
        this.name &&
        this.surname &&
        this.phone &&
        this.email &&
        this.pass &&
        this.passConfirm &&
        this.terms
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
  },
  methods: {
    submitRegister() {
      let regData = {
        name: this.name,
        surname: this.surname,
        email: this.email,
        phone: this.phone,
        password: this.pass,
        passConfirm: this.passConfirm,
      };
      this.$emit("registration", regData);
    },
  },
};
</script>
